import React, { useState } from 'react';
import { iconForField } from '../../common/custom/icon-library';
import { ErrorMessage, Field, Formik, Form } from 'formik';
import CustomLoader from '../common/CustomLoader';
import TooltipInfo from '../../common/docs/TooltipInfo';
import CustomRadio from '../../common/ui/CustomRadio';
import CustomSelect from '../home/collections/CustomSelect';
import { validateNamesForField } from '../../common/utils/validate';
export const CsvDataDisplay = ({
  csvHeader,
  onUpdateJsonConfig,
  collectionName,
  setCollectionName,
  jsonConfig,
  onSubmitForm,
  actions,
  isPersistent,
  setCheckboxChange,
  typeDescription,
  collections,
}) => {
  const [fieldDataTypes, setFieldDataTypes] = useState([]);
  const [isCollectionNameValid, setIsCollectionNameValid] = useState(true);
  const [csvHeaders, setCsvHeaders] = useState([...csvHeader]);
  const handleDataTypeChange = (field, dataType) => {
    setFieldDataTypes((prevDataTypes) => ({ ...prevDataTypes, [field]: dataType }));
  };
  const initialValues = Object.fromEntries(
    csvHeaders.map((header, index) => [`header_${index}`, header]),
  );

  const handleSave = (values) => {
    if (!collectionName) {
      setIsCollectionNameValid(false);
    } else if (!validateCollectionName(collectionName)) {
      setIsCollectionNameValid(false);
    } else {
      const updatedJsonConfig = {};
      csvHeaders.forEach((header, index) => {
        const fieldName = `header_${index}`;
        const newFieldName = values[fieldName];
        const oldFieldName = csvHeaders[index];

        if (newFieldName !== oldFieldName) {
          updatedJsonConfig[newFieldName] = updatedJsonConfig[oldFieldName];
          delete updatedJsonConfig[oldFieldName];
        }
        updatedJsonConfig[newFieldName] = fieldDataTypes[header]
          ? fieldDataTypes[header].value
          : 'text';
      });
      setCollectionName(collectionName);
      onUpdateJsonConfig(updatedJsonConfig);
      onSubmitForm();
    }
  };
  const validateCollectionName = (name) => {
    const isValid = /^[a-zA-Z\s]+$/.test(name);
    return isValid;
  };
  const handleDeleteField = (index) => {
    const updatedFieldDataTypes = { ...fieldDataTypes };
    const updatedCsvHeader = csvHeaders.filter((header, i) => i !== index);
    setFieldDataTypes(updatedFieldDataTypes);
    setCsvHeaders(updatedCsvHeader);
  };
  const handleCancel = () => {
    actions.toggleIsOpenCollectionCreateWithCsv();
  };
  const handleCheckboxChange = (e) => {
    setCheckboxChange(e);
  };
  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
          <div className="form-group">
            <div className="input-group">
              <div className="input-group-prepend" title="Collection Title">
                <span className="input-group-text">
                  <i className={`wb ${iconForField('text')}`}></i>
                  <span className="required"> *</span>
                </span>
              </div>
              <Field
                type="text"
                name="collectionTitle"
                className="form-control form-control-sm"
                id="collectionTitle"
                value={collectionName}
                placeholder="Collection Name"
                title="Edit Collection Name"
                onChange={(e) => {
                  setCollectionName(e.target.value);
                  setIsCollectionNameValid(true);
                }}
              />
              {!isCollectionNameValid && !collectionName && (
                <p className="text-danger">Collection Name can't be blank.</p>
              )}
              {!isCollectionNameValid && collectionName && (
                <p className="text-danger">
                  Collection Name should not contain special characters or numbers.
                </p>
              )}
              <TooltipInfo
                title={`Enter Collection Name of your choice. It should not contain special characters or numbers.`}
                headerText={`Collection Name`}
                showHeader={true}
                showArrow={true}
                append={true}
              />
            </div>
          </div>
          <div className="form-group">
            <div className="input-group">
              <div className="input-group-prepend" title="Persistent Collection">
                <span className="input-group-text">
                  <i className="wb webconnect-toggles"></i>
                  <span className="required">*</span>
                </span>
              </div>
              <div className="form-check" style={{ marginTop: '8px' }}>
                <CustomRadio label="Persistent Collection" isRadio={false}>
                  <input
                    name="willPersist"
                    type="checkbox"
                    className="form-check-input"
                    checked={isPersistent}
                    onChange={handleCheckboxChange}
                  />
                </CustomRadio>
              </div>
              <TooltipInfo
                title={typeDescription}
                headerText={`What's Persistent Collection?`}
                showHeader={true}
                showArrow={true}
                append={true}
              />
            </div>
          </div>
          <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode ">
            <div className="form-row mb-3">
              <div className="col-sm-6">
                <b>Fields</b>
              </div>
              <div className="col-sm-6">
                <b>Field Types</b>
              </div>
            </div>
            <Formik
              key={JSON.stringify(initialValues)}
              initialValues={initialValues}
              onSubmit={handleSave}
            >
              {({ values, handleChange, setFieldValue }) => (
                <Form className="form-row">
                  <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
                    {csvHeaders.map((header, index) => (
                      <div key={index} className="form-row">
                        <div className="col-sm-6">
                          <Field
                            type="text"
                            name={`header_${index}`}
                            className="form-control form-control-sm"
                            id={index}
                            value={values[`header_${index}`]}
                            onChange={handleChange}
                            validate={validateNamesForField}
                          />
                        </div>
                        <div className="col-sm-5">
                          <CustomSelect
                            name={header}
                            isMulti={false}
                            onChange={setFieldValue}
                            onChangeValue={handleDataTypeChange}
                            options={[
                              { label: 'String', value: 'text' },
                              { label: 'Number', value: 'number' },
                              { label: 'Boolean', value: 'boolean' },
                            ]}
                            value={fieldDataTypes[header] || { label: 'String', value: 'text' }}
                          />
                        </div>
                        <button
                          className="btn btn-xs btn-theme-delete btn-icon-only ml-1"
                          type="button"
                          onClick={() => handleDeleteField(index)}
                        >
                          <i className="wb webconnect-times"></i>
                        </button>
                        <p className="errors">
                          <ErrorMessage name={`header_${index}`}></ErrorMessage>
                        </p>
                      </div>
                    ))}
                    <div className="d-flex justify-content-between align-items-center">
                      <button
                        className="btn btn-outline-secondary btn-sm"
                        title="Cancel"
                        type="button"
                        onClick={handleCancel}
                      >
                        <i className="wb webconnect-times"></i> Cancel
                      </button>
                      <button
                        type="submit"
                        className="btn btn-theme-submit btn-sm"
                        title="Save Collection"
                        disabled={collections.createCollectionWithCsvPending}
                      >
                        <i className="wb webconnect-save-regular"></i> Save
                        <CustomLoader
                          loading={collections.createCollectionWithCsvPending}
                        ></CustomLoader>
                      </button>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
};
